/* eslint-disable @typescript-eslint/no-explicit-any */
import api from '@/services/api';
import { Config } from '@/types';

export async function serviceListConfigs() {
  try {
    const response = await api.get<Config[]>('/configs');
    return response.data;
  } catch (error: any) {
    const messageError = error?.response?.data?.message || error?.message;
    if (messageError) {
      throw new Error(messageError);
    }
    throw new Error('Erro interno do servidor');
  }
}

export async function serviceUpdateConfig(config: Config) {
  try {
    const response = await api.put<Config>(`/configs/${config.id}`, {
      value: config.value,
    });
    return response.data;
  } catch (error: any) {
    const messageError = error?.response?.data?.message || error?.message;
    if (messageError) {
      throw new Error(messageError);
    }
    throw new Error('Erro interno do servidor');
  }
}
